async function getRestaurants(token) {
  const requestOptions = {
    method: 'GET',
    headers: { 'x-auth-token': token },
  };

  const restaurants = await fetch(
    'https://book-backend-ki7x.onrender.com/api/restaurants/',
    requestOptions,
  );

  return restaurants;
}

export default getRestaurants;
